<ion-item *ngIf="recording" lines="none">
  <ion-checkbox
    mode="md"
    *ngIf="appearance === 'dashboard'"
    slot="start"
    [checked]="recording.isChecked"
    (ionChange)="checked($event)"></ion-checkbox>

  <ion-label class="ion-text-wrap" style="width: 0">
    <p class="pica-bold">
      {{ recording.fileName | fileName : 'name' }}
      <ion-badge *ngIf="recording.preview" class="preview-badge"> PREVIEW </ion-badge>
      <sc-recordings-tag *ngIf="isMigrated" [tag]="recordingsTag.MIGRATED"></sc-recordings-tag>
      <sc-recordings-tag *ngIf="recordingTag" [tag]="recordingTag"></sc-recordings-tag>
    </p>
    <!-- <p class="micro-regular">
      {{ recording.fileName | fileName : 'date' }}
      {{ recording.fileName | fileName : 'time' }}

      <ion-badge *ngIf="recording.preview" class="sc-color-black-75 sc-color-secondary-light-mode-bg pica-bold-caps">
        PREVIEW
      </ion-badge>
      <sc-recordings-tag *ngIf="isMigrated" [tag]="recordingsTag.MIGRATED"></sc-recordings-tag>
      <sc-recordings-tag *ngIf="recordingTag" [tag]="recordingTag"></sc-recordings-tag>
    </p> -->
  </ion-label>

  <ion-badge color="warning" [tooltip]="recording.warnings.join(', ')" *ngIf="recording.warnings?.length">
    Warnings!
  </ion-badge>

  <div class="spinner-container" *ngIf="recording.percentage && recording.percentage < 100">
    <mat-progress-spinner
      mode="determinate"
      [value]="recording.percentage"
      [tooltip]="
        recording.renderFailed
          ? 'Failed To Render'
          : !recording.percentage
          ? 'Uploading Audio'
          : recording.percentage + '% Rendered'
      "
      diameter="30"
      strokeWidth="2"
      class="video"></mat-progress-spinner>

    <ion-icon
      src="/assets/icons/32px/recordings-bold.svg"
      [tooltip]="
        recording.renderFailed
          ? 'Failed To Render'
          : !recording.percentage
          ? 'Uploading Audio'
          : recording.percentage + '% Rendered'
      "
      class="progress video"></ion-icon>
  </div>

  <div
    class="spinner-container"
    *ngIf="
      !recording.noCamera &&
      recording.fileName &&
      !recording.fileName.includes('mix') &&
      recording.hadVideoPlanAtRecording &&
      recording.videoPercentage &&
      recording.videoPercentage < 100
    ">
    <mat-progress-spinner
      mode="determinate"
      [value]="recording.videoPercentage"
      [tooltip]="
        recording.renderFailed
          ? 'Failed To Render'
          : !recording.videoPercentage
          ? 'Uploading Video'
          : recording.videoPercentage + '% Rendered'
      "
      diameter="30"
      strokeWidth="2"
      class="audio"></mat-progress-spinner>

    <ion-icon
      src="/assets/icons/24px/video-playback.svg"
      [tooltip]="
        recording.renderFailed
          ? 'Failed To Render'
          : !recording.videoPercentage
          ? 'Uploading Video'
          : recording.videoPercentage + '% Rendered'
      "
      class="progress audio"></ion-icon>
  </div>

  <ion-button
    *ngIf="recording && (role$ | async) >= roleLimits.RECORDING_READ && (recording.wav || recording.mp3)"
    (click)="togglePlaybackVisible('audio', recording)"
    [tooltip]="appearance === 'dashboard' ? '' : 'Listen'"
    aria-label="Listen to Recording"
    class="playback"
    [class.open]="recording.audioPlaybackVisible"
    [class.dashboard]="appearance === 'dashboard'">
    <ion-icon
      src="/assets/icons/24px/headphones.svg"
      [slot]="appearance === 'dashboard' ? 'start' : 'icon-only'"></ion-icon>

    <span *ngIf="appearance === 'dashboard'">Listen</span>
  </ion-button>

  <ion-button
    *ngIf="(role$ | async) >= roleLimits.RECORDING_READ && (recording.mp4 || recording.webm || recording.rawURL)"
    (click)="togglePlaybackVisible('video', recording)"
    [tooltip]="appearance === 'dashboard' ? '' : 'Watch'"
    aria-label="Watch Recording"
    class="playback"
    [class.open]="recording.videoPlaybackVisible"
    [class.dashboard]="appearance === 'dashboard'">
    <ion-icon
      src="/assets/icons/24px/playback.svg"
      [slot]="appearance === 'dashboard' ? 'start' : 'icon-only'"></ion-icon>

    <span *ngIf="appearance === 'dashboard'">Watch</span>
  </ion-button>

  <ion-button
    *ngIf="(role$ | async) >= roleLimits.RECORDING_READ"
    (click)="openRecordingMenu(recording, $event)"
    aria-label="Manage Recording"
    tooltip="Manage Recording"
    class="more">
    <ion-icon src="/assets/icons/24px/more-vertical.svg" slot="icon-only"></ion-icon>
  </ion-button>
</ion-item>
<div class="progress-wrapper" *ngIf="recording">
  <div
    class="audio-progress"
    [tooltip]="'Audio: ' + (audioUploadProgress * 100).toFixed(0) + '% uploaded'"
    *ngIf="audioStats && (recording.preview !== false || recording.renderFailed)">
    <ion-icon src="/assets/icons/32px/recordings-bold.svg"></ion-icon>
    <ion-progress-bar [value]="audioUploadProgress" [buffer]="audioUploadProgress"></ion-progress-bar>
    <ion-icon src="/assets/icons/24px/upload.svg"></ion-icon>
  </div>
  <div
    class="video-progress"
    [tooltip]="'Video: ' + (videoUploadProgress * 100).toFixed(0) + '% uploaded'"
    *ngIf="videoStats && (recording.preview !== false || recording.renderFailed)">
    <ion-icon src="/assets/icons/24px/video-playback.svg"></ion-icon>
    <ion-progress-bar [value]="videoUploadProgress" [buffer]="videoUploadProgress"></ion-progress-bar>
    <ion-icon src="/assets/icons/24px/upload.svg"></ion-icon>
  </div>
  <div
    class="screen-progress"
    [tooltip]="'Screenshare: ' + (screenUploadProgress * 100).toFixed(0) + '% uploaded'"
    *ngIf="screenStats && (recording.preview !== false || recording.renderFailed)">
    <ion-icon src="/assets/icons/24px/screenshare.svg"></ion-icon>
    <ion-progress-bar [value]="screenUploadProgress" [buffer]="screenUploadProgress"></ion-progress-bar>
    <ion-icon src="/assets/icons/24px/upload.svg"></ion-icon>
  </div>
</div>

<ion-item
  *ngIf="recording && (recording.audioPlaybackVisible || recording.videoPlaybackVisible)"
  [lines]="last ? 'none' : 'inset'">
  <sc-player
    [url]="
      recording.videoPlaybackVisible
        ? recording.mp4 || recording.webm || recording.rawURL
        : this.recording.mp3 || this.recording.wav
    "></sc-player>
</ion-item>

<ion-item *ngIf="!recording" lines="none">
  <ion-label>
    <h2><ion-skeleton-text></ion-skeleton-text></h2>
  </ion-label>
</ion-item>
